import React from 'react';
import './toast.scss';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function Toast({ message, type, close }) {
  if (!message) {
    return null; // Don't render anything if there's no message
  }
  return (
    <Snackbar
      open={!!message}
      autoHideDuration={12000}
      onClose={close}
      message={message}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      className={`toast__snackbar ${type}`}
    >
      <Alert severity={type} onClose={close} variant={'filled'}>
        {message}
      </Alert>
    </Snackbar>
  );
}
